module.exports = "/_next/static/images/ship-monotone-bd1a9af9151f251e6b53fd5da9622d45.svg";